export enum TagType {
  SURVEY = 'survey',
  INSTRUCTOR = 'instructor',
  ROOM = 'room',
  TASK = 'tasks',
  NEWS = 'news',
  EVENT = 'events',
  EVENT_VENUES = 'event_venues',
  COURSES = 'courses',
}
